import { render } from "./Campaign.vue?vue&type=template&id=42805bd2&scoped=true"
import script from "./Campaign.vue?vue&type=script&lang=js"
export * from "./Campaign.vue?vue&type=script&lang=js"

import "./Campaign.vue?vue&type=style&index=0&id=42805bd2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42805bd2"]])

export default __exports__